module.exports = __webpack_public_path__ + "media/packs/user-cards/images/success-86aa50461a1b333e769a24bc1406971d.svg";